import React from 'react';

import styled from 'styled-components';

import { useTranslation } from 'react-i18next';

import { MilstonePolygon, GateCircle } from '../../Constants/assets';

const TableDefinitions = styled.div`
    width: 92%;
    margin: 5px auto;
    height: 37px;
    display: flex;
    border: 1px solid #ebeced;
`;
const TableRow = styled.div`
    display: grid;
    grid-template-columns: 5% 23% 18% 18% 18% 15%;
    height: 100%;
    width: 100%;
    border-radius: '4px';
    align-items: center;
`;
const TableData = styled.div`
    line-height: 21.8px;
    font-size: 16px;
    width: max-contact;
    margin-left: 10px;
`;
const MilestonePolygonSmall = styled(MilstonePolygon)`
    width: 22px;
    height: 22px;
`;
const GateCircleIcon = styled(GateCircle)`
    width: 22px;
    height: 22px;
`;
const LogoNumber = styled.div`
    font-size: 12px;
    position: relative;
    margin-bottom: 1rem;
`;

function returnMilestoneStyleBasedOnId(id) {
    const _style = {
        fontSize: '0.6875rem',
        position: 'absolute',
        color: '#fff',
        marginTop: '-1.5rem', // default milestone tile 6 parameters
        marginLeft: '0.5rem', // default milestone tile 6 parameters
    };

    if (id > 19) {
        // milestone tiles over 18
        _style.marginTop = '-1.5rem';
        _style.marginLeft = '0.299rem';
        return <LogoNumber style={_style}>{id}</LogoNumber>;
    }
    if (id > 9) {
        // milestone tile with the number 18
        _style.marginTop = '-1.5rem';
        _style.marginLeft = '0.26rem';

        return <LogoNumber style={_style}>{id}</LogoNumber>;
    }

    // milestone tile 6
    return <LogoNumber style={_style}>{id}</LogoNumber>;
}

export default function TableLine({
    id,
    name,
    icon,
    Additional,
    Cost,
    blueAmount,
    greenAmount,
    redAmount,
}) {
    const { t } = useTranslation();

    return (
        <TableDefinitions>
            <TableRow>
                <TableData>
                    {name == 'gate' && (
                        <div style={{ alignContent: 'center' }}>
                            <GateCircleIcon />
                            <div
                                style={{
                                    boxSizing: 'border-box',
                                    position: 'relative',
                                    borderColor: '#005857',
                                    width: '28px',
                                    height: '28px',
                                    left: '-2.4px',
                                    marginTop: '-1.55rem',
                                    borderRadius: '50px',
                                    border: '1px solid #81818C',
                                }}
                            />
                            {id > 9 ? (
                                <LogoNumber
                                    style={{
                                        color: '#fff',
                                        position: 'absolute',
                                        marginTop: '-1.55rem',
                                        marginLeft: '0.294rem',
                                        fontSize: '0.6875rem',
                                    }}
                                >
                                    {id}
                                </LogoNumber>
                            ) : (
                                <LogoNumber
                                    style={{
                                        color: '#fff',
                                        position: 'absolute',
                                        marginTop: '-1.55rem',
                                        marginLeft: '0.5rem',
                                        fontSize: '0.6875rem',
                                    }}
                                >
                                    {id}
                                </LogoNumber>
                            )}
                        </div>
                    )}
                    {name == 'milestone' && (
                        <div style={{ alignContent: 'center' }}>
                            <MilestonePolygonSmall />
                            <div
                                style={{
                                    boxSizing: 'border-box',
                                    position: 'relative',
                                    width: '28px',
                                    height: '28px',
                                    left: '-2.4px',
                                    marginTop: '-1.55rem',
                                    borderRadius: '50px',
                                    border: '1px solid #005857',
                                }}
                            />
                            {returnMilestoneStyleBasedOnId(id)}
                        </div>
                    )}
                </TableData>
                <TableData style={{ width: 'max-contact' }}>
                    {t(`global_variables.game_element.${name}`, { name })} {Additional}
                </TableData>
                <TableData style={{ width: '49px' }}>${Cost}</TableData>
                <TableData style={{ width: '9px' }}>{blueAmount}</TableData>
                <TableData style={{ width: '9px' }}>{redAmount}</TableData>
                <TableData style={{ width: '9px' }}>{greenAmount}</TableData>
            </TableRow>
        </TableDefinitions>
    );
}
